import React, { Component } from 'react';
import _ from 'lodash';
import { ITableGridProps } from '../../types/propTypes';
import { ITableGridState } from '../../types/stateTypes';
import { ITableColumn } from '../../models/table';

class Table extends Component<ITableGridProps, ITableGridState> {
    constructor(props: ITableGridProps) {
        super(props);
        this.state = {
            data: props.data,
            columns: props.columns,
            sortOrder: 'desc',
            sortColumn: '',
            rowsPerPage: props.rowsPerPage,
            currentPage: props.currentPage,
            isAllChecked: false,
        };
    }

    UNSAFE_componentWillReceiveProps(props: ITableGridProps) {
        this.setState({
            ...this.state,
            data: props.data,
            currentPage: props.currentPage,
            rowsPerPage: props.rowsPerPage,
            sortColumn: props.sortColumn,
            sortOrder: props.sortOrder,
        });
    }

    getClass = (header: ITableColumn): string => {
        let className = '';
        if (header.sortable) {
            className = 'sorting';
        }
        if (header.id === this.state.sortColumn) {
            className = `sorting_${this.state.sortOrder}`;
        }
        return header.className ? `${className} ${header.className}` : className;
    };
    getPageNo = (iCount: number, start: number, noOfPage: number, endPage: number): JSX.Element => {
        let pageNo = iCount;
        let pageNoDisplay = iCount.toString();
        if (iCount !== 1 && start === 1) {
            pageNo = 1;
            pageNoDisplay = '1...';
        }

        if (iCount !== 1 && start === 1) {
            pageNo = 1;
            pageNoDisplay = '1...';
        }

        if (iCount === endPage && iCount !== noOfPage) {
            pageNo = noOfPage;
            pageNoDisplay = `...${noOfPage}`;
        }

        return (
            <span
                className={this.props.currentPage === iCount ? 'pagination-span active' : 'pagination-span'}
                onClick={(e) => {
                    e.preventDefault();
                    this.props.handlePageChange(pageNo, this.state.rowsPerPage);
                }}
                data-testid="pagination_span_getPageNo"
            >
                {pageNoDisplay}
            </span>
        );
    };
    renderPageList = (): Array<JSX.Element> => {
        const noOfPage = Math.ceil(this.props.totalCount / this.props.rowsPerPage);
        const pageList = [];
        let startPage = 1;
        if (this.props.currentPage - 2 >= 1) {
            startPage = this.props.currentPage - 2;
        }
        let endPage = noOfPage < startPage + 4 ? noOfPage : startPage + 4;
        if (startPage + 4 > noOfPage) {
            endPage = noOfPage;
        }
        if (this.props.currentPage === noOfPage) {
            startPage = this.props.currentPage - 4 >= 1 ? this.props.currentPage - 4 : 1;
        }
        if (this.props.currentPage > 1) {
            pageList.push(
                <li key="page-prev">
                    <span
                        className="pagination-span prevar"
                        onClick={(e) => {
                            e.preventDefault();
                            this.props.handlePageChange(this.props.currentPage - 1, this.state.rowsPerPage);
                        }}
                    >
                        {this.props.t('table.pagination.prev')}
                    </span>
                </li>,
            );
        }
        for (let iCount = startPage, start = 1; iCount <= endPage; iCount++, start++) {
            pageList.push(<li key={iCount}>{this.getPageNo(iCount, start, noOfPage, endPage)}</li>);
        }
        if (this.props.currentPage < noOfPage) {
            pageList.push(
                <li key="page-next">
                    <a
                        href="#"
                        className="nxtar"
                        onClick={(e) => {
                            e.preventDefault();
                            this.props.handlePageChange(this.props.currentPage + 1, this.state.rowsPerPage);
                        }}
                    >
                        {this.props.t('table.pagination.nrev')}
                    </a>
                </li>,
            );
        }
        return pageList;
    };

    getCheckboxRecordLength = () => {
        if (this.props.isCheckboxShow) {
            let checkCount = 0;
            this.props.data.forEach((element) => {
                if (this.props.isCheckboxShow(element)) {
                    checkCount++;
                }
            });
            return checkCount;
        }
        return this.props.data.length;
    };
    checkedAlltheData = () => {
        const copyRecord = this.props.checkedRecord;
        const uncheckedRecordCopy = this.props.uncheckedRecord;
        const check_response = this.AllFieldCheckbox();
        this.props.data.forEach((element) => {
            const data = copyRecord.find((e) => e === element.id);
            if (!check_response) {
                if (!data) {
                    if (!this.props.isCheckboxShow || this.props.isCheckboxShow(element)) {
                        copyRecord.push(element.id);
                        if (uncheckedRecordCopy) {
                            _.remove(uncheckedRecordCopy, function (e) {
                                return e === element.id;
                            });
                        }
                    }
                }
            } else {
                if (data) {
                    _.remove(copyRecord, function (e) {
                        return e === element.id;
                    });
                    if (uncheckedRecordCopy) {
                        uncheckedRecordCopy.push(element.id);
                    }
                }
            }
        });
        this.props.setCheckedRecord(copyRecord);
        if (uncheckedRecordCopy) {
            this.props.setUncheckedRecord(uncheckedRecordCopy);
        }
    };

    AllFieldCheckbox = () => {
        let checkCount = 0;
        this.props.data.forEach((element) => {
            const res = _.find(this.props.checkedRecord, (e) => {
                if (e === element.id) {
                    return true;
                } else {
                    return false;
                }
            });
            if (res) {
                checkCount++;
            }
        });
        return this.props.data.length > 0 && checkCount && checkCount === this.getCheckboxRecordLength();
    };

    checkedRow = (row: any, index: number) => {
        const data = this.props.checkedRecord.find((e) => e === row.id);
        const copyRecord = this.props.checkedRecord;
        const uncheckedRecordCopy = this.props.uncheckedRecord;
        if (!data) {
            copyRecord.push(row.id);
            if (uncheckedRecordCopy) {
                _.remove(uncheckedRecordCopy, function (e) {
                    return e === row.id;
                });
            }
        } else {
            _.remove(copyRecord, function (e) {
                return e === row.id;
            });
            if (uncheckedRecordCopy) {
                uncheckedRecordCopy.push(row.id);
            }
        }

        let checkCount = 0;
        this.props.data.forEach((element) => {
            const res = _.find(copyRecord, (e) => {
                if (e === element.id) {
                    return true;
                } else {
                    return false;
                }
            });
            if (res) {
                checkCount++;
            }
        });
        if (checkCount === this.props.data.length) {
            this.setState(
                {
                    isAllChecked: true,
                },
                () => {
                    this.props.setCheckedRecord(copyRecord);
                    if (uncheckedRecordCopy) {
                        this.props.setUncheckedRecord(uncheckedRecordCopy);
                    }
                },
            );
        } else {
            this.setState(
                {
                    isAllChecked: false,
                },
                () => {
                    this.props.setCheckedRecord(copyRecord);
                    if (uncheckedRecordCopy) {
                        this.props.setUncheckedRecord(uncheckedRecordCopy);
                    }
                },
            );
        }
    };

    render() {
        return (
            <>
                <div className={`table-responsive grid-table min-height ${this.props.classNamesProps}`}>
                    <table className="table table-border">
                        <thead>
                            <tr>
                                {this.props.isCheckboxGrid && (
                                    <th>
                                        <div className="custom-control custom-checkbox custom-control-inline">
                                            <input
                                                type="checkbox"
                                                className="custom-control-input"
                                                id="allData"
                                                checked={this.AllFieldCheckbox()}
                                                onChange={this.checkedAlltheData}
                                            />
                                            <label className="custom-control-label pb-0" htmlFor="allData"></label>
                                        </div>
                                    </th>
                                )}
                                {this.props.columns.length > 0 &&
                                    this.props.columns.map((header: ITableColumn, index: number): JSX.Element => {
                                        if (!header.isVisible) return null;
                                        return (
                                            <th
                                                className={this.getClass(header)}
                                                {...header.props}
                                                key={index}
                                                style={header.style ? header.style : {}}
                                                onClick={() => {
                                                    header.sortable && this.props.handleSorting(header.id);
                                                }}
                                            >
                                                {header.headerCell ? (
                                                    header.headerCell()
                                                ) : (
                                                    <span
                                                        dangerouslySetInnerHTML={{
                                                            __html: header.label,
                                                        }}
                                                    ></span>
                                                )}
                                            </th>
                                        );
                                    })}
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.data &&
                                this.props.data.length > 0 &&
                                this.props.data.map((row: any, index: number) => {
                                    return (
                                        <tr key={index}>
                                            {this.props.isCheckboxGrid && (
                                                <td>
                                                    {(!this.props.isCheckboxShow || this.props.isCheckboxShow(row)) && (
                                                        <div className="custom-control custom-checkbox custom-control-inline mr-0">
                                                            <input
                                                                type="checkbox"
                                                                className="custom-control-input"
                                                                id={`tbl${row.id}`}
                                                                value={row.id}
                                                                key={Math.random()}
                                                                checked={
                                                                    this.props.checkedRecord &&
                                                                    this.props.checkedRecord.length > 0
                                                                        ? _.find(this.props.checkedRecord, (e) => {
                                                                              if (e === row.id) {
                                                                                  return true;
                                                                              }
                                                                              return false;
                                                                          })
                                                                        : false
                                                                }
                                                                onChange={() => this.checkedRow(row, index)}
                                                            />
                                                            <label
                                                                className="custom-control-label pb-0"
                                                                htmlFor={`tbl${row.id}`}
                                                            ></label>
                                                        </div>
                                                    )}
                                                </td>
                                            )}
                                            {Object.entries(this.props.columns).map(
                                                (col, cellIndex: number): JSX.Element => {
                                                    const column = this.props.columns[cellIndex];
                                                    if (!column.isVisible) return null;
                                                    const columnName = column.id;
                                                    const cellValue = _.get(row, columnName);
                                                    return (
                                                        <td
                                                            key={cellIndex}
                                                            className={column.className ? column.className : ''}
                                                            style={column.style ? column.style : {}}
                                                            {...column.props}
                                                        >
                                                            {column.cell ? column.cell(row) : cellValue}
                                                        </td>
                                                    );
                                                },
                                            )}
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                    {this.props.data && this.props.data.length <= 0 && (
                        <p className="text-center mt-2">{this.props.t('table.data.noData')}</p>
                    )}
                </div>
                {this.props.data &&
                    this.props.data.length > 0 &&
                    (this.props.allowPageing === undefined || this.props.allowPageing === true) && (
                        <div className="container-fluid">
                            <div className="grid-bottom row">
                                <div className="col-lg">
                                    <div className="show-record">
                                        <span className="form-label">{this.props.t('table.pagination.showing')}</span>
                                        <select
                                            className="custom-select"
                                            value={this.props.rowsPerPage}
                                            onChange={(e) => this.props.handlePageChange(1, parseInt(e.target.value))}
                                        >
                                            <option value="10">10</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-lg">
                                    <div className="paginetion">
                                        <ul className="clearfix">{this.renderPageList()}</ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
            </>
        );
    }
}

export default Table;
